import { APPLICATION_FLOW_STATUS } from 'typescript/types/api/capital_shop/application_flows';
import { usePaymentContext } from 'typescript/context/payment_context';
import { useCheckoutFlow } from 'typescript/context/checkout_flow';
import { useCreateFinancingDisclosures } from 'typescript/hooks/use_financing_disclosures_client';
import { useCompleteOrderContext } from 'typescript/context/complete_order_context';
import { CompleteOrderError } from 'typescript/constants/enums/checkout';

const useHandleFinancingSubmission = () => {
  const { orderNumber } = useCheckoutFlow();

  const {
    submittingPayment,
    setSubmittingPayment,
    setShowInstallmentDecision,
    setPollingCapitalShop,
    setDisclosureDocumentToken,
    setApplicationFlowStatus,
    setShowDisclosureModal,
  } = usePaymentContext();
  const {
    setCompleteOrderError,
    setShowCompletingOrderDialog,
    setShowAlternateCompletingCopy,
  } = useCompleteOrderContext();

  const { createFinancingDisclosure } = useCreateFinancingDisclosures({
    orderNumber,
  });

  const handleFinancingDisclosure = () => {
    createFinancingDisclosure(
      {},
      {
        onSuccess: (data) => {
          const documentToken = data.disclosure_document_token;
          setDisclosureDocumentToken(documentToken);
          setShowDisclosureModal(true);
          setSubmittingPayment(false);
          setShowCompletingOrderDialog(false);
          setShowAlternateCompletingCopy(false);
        },
        onError: () => {
          setCompleteOrderError(CompleteOrderError.GENERIC);
          setSubmittingPayment(false);
          setShowCompletingOrderDialog(false);
        },
      },
    );
  };

  const handleDecisionStatusChange = ({
    decisionStatus,
  }: {
    decisionStatus: APPLICATION_FLOW_STATUS;
  }) => {
    if (
      !submittingPayment ||
      decisionStatus === undefined ||
      decisionStatus === APPLICATION_FLOW_STATUS.SUBMITTED
    ) {
      return;
    }

    setPollingCapitalShop(false);

    if (
      decisionStatus === APPLICATION_FLOW_STATUS.PENDING ||
      decisionStatus === APPLICATION_FLOW_STATUS.DECLINED
    ) {
      setSubmittingPayment(false);
      setShowCompletingOrderDialog(false);
      setShowInstallmentDecision(true);
      setApplicationFlowStatus(decisionStatus);
    } else if (decisionStatus === APPLICATION_FLOW_STATUS.REVIEWED) {
      handleFinancingDisclosure();
    }
  };

  return {
    handleDecisionStatusChange,
    handleFinancingDisclosure,
  };
};

export default useHandleFinancingSubmission;
